// NOTE: very slightly adapted from https://github.com/offirgolan/ember-validators/blob/52ac5488b5ce80a12ee87471b5b505c5adff46c0/addon/format.js#L32 to allow leading and trailing whitespace. sometimes people cut and paste emails and inadvertently include whitespace which is difficult to see when the address fails validation. consequently, the API strips whitespace from emails, so we don't need to worry about catching it here.
// NOTE: original regexp also modified to remove redundant escapes of / and make our linter STFU
const EMAIL_REGEXP =
  /^\s*[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\s*$/i;

/**
 * Test an arg to see if it looks like an email address
 *
 * @param {unknown} maybeEmailAddress
 * @returns {Boolean}
 */
export default function isEmailAddress(maybeEmailAddress) {
  if (maybeEmailAddress === null || typeof maybeEmailAddress !== 'string') {
    return false;
  }

  return EMAIL_REGEXP.test(maybeEmailAddress);
}
